<template>
  <div class="container">
    <el-dialog :close-on-click-modal="false"
      title="选择书单"
      :visible.sync="dialogVisible"
      @close="close"
      width="30%"
      >
      <div class="dialogMain">
        <p><el-button type="primary" @click="showNewFlag">新建书单</el-button></p>
        <div class="newFlag" v-if="newFlag">
          <p><el-input placeholder="请输入书单" v-model="bookVal"></el-input></p>
          <p class="btnList">
            <el-button @click="newFlag = false">取 消</el-button>
            <el-button type="primary" @click="sure">确 定</el-button>
          </p>
        </div>

        <p class="book flex_a" v-show="!newFlag">
          <span>书单：</span>
           <el-select v-model="selectRuid" placeholder="请选择" @change="getSelectVal" :popper-append-to-body="false">
              <el-option
                v-for="item in options"
                :key="item.ruid"
                :label="item.name"
                :value="item.ruid">
              </el-option>
            </el-select>
        </p>
      </div>
      <span slot="footer" class="dialog-footer" v-show="!newFlag">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="addBookList">确 定</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
export default {
  name: "dialogAdd",
  props:{
    dataList:{
      type: Array,
      default:() => {
          return []
      }
    },
    dialogFlag:{
      type: Boolean,
      default:() => {
          return []
      }
    }
  },
  watch:{
    dialogFlag(val){
      this.dialogVisible = val
    },
    dataList(val) {
      this.dataListArray = val
    }
  },
  data() {
    return {
      dialogVisible: false,
      newFlag: false,
      bookVal: '',
      dataListArray: [],
      options: [],
      value: '',
      selectRuid:'',
    };
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      this.$http({
        url: `/api/v1/customer/search/user_booklist?pagesize=100000&pageno=0&orderfield=CONVERT(name using gbk)&ordertype=A`,
        method: "POST",
      }).then(res => {
        if(res.returnvalue){
          this.options = res.returnvalue.recordlist
        }
      });

    },
    showNewFlag() {
        this.newFlag = true
        this.bookVal = ''
    },
    close() {
      this.selectRuid = ''
      this.dialogVisible = false
      this.$emit('childByFlag', this.dialogVisible)
    },
    sure() {
      if(!this.bookVal.trim()){
        this.$message.error('请输入书单')
        return
      }
      this.$http({
        url: `/api/v1/customer/booklist/save`,
        method: "POST",
        data: {
          description: "",
          name: this.bookVal,
          ruid: "",
          type: "10"
        }

      }).then(res => {
        this.$message.success('新增成功')
        this.getList()
        this.newFlag = !this.newFlag
      });

    },
    getSelectVal(val) {
      this.selectRuid = val
    },
    addBookList() {
      if(!this.selectRuid){
        this.$message.error('请选择书单')
        return
      }
      this.$http({
        url: `/api/v1/customer/booklist/addData`,
        method: "POST",
        data: {
          booklistRuid: this.selectRuid,
          dataList: this.dataListArray
        }
      }).then(res => {
        this.$message.success('收藏成功')
        this.dialogVisible = false
        this.$emit('childByBook', true)
      });
    }


  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
/deep/ .el-popper{
  width: 200px !important;
}
.container {
  .book{
    text-align: center;
    margin-top: 30px;
    span{
      width: 70px;
      display: inline-block;
    }
  }
  .newFlag{
    text-align: center;
    margin-top: 30px;
  }
  .el-input{
    width: 50%;
  }
  .btnList{
    margin-top: 30px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/dialogAdd.vue